const terms = {
  title: '이용 약관',
  description: 'Plannely 앱과 웹사이트의 이용 약관입니다. 계정, 구독, 사용자 콘텐츠 및 서비스 이용 규칙을 설명합니다.',
  effectiveLabel: '시행일:',
  effectiveDate: '2026년 11월 5일',
  appLabel: '앱:',
  privacyPhrases: ['개인정보 처리방침'],
  sections: [
    {
      title: '본 약관에 대한 동의',
      body: [
        '본 이용 약관(이하 "약관")은 Plannely 모바일 앱과 웹사이트 https://plannely.app (이하 통칭하여 "서비스")의 이용에 적용됩니다. 서비스는 SEOTIV(이하 "당사")가 제공합니다.',
        '계정을 만들거나 서비스를 이용하면 본 약관에 동의하는 것입니다. 동의하지 않으면 서비스를 이용하지 마십시오. 당사의 개인정보 처리방침(https://plannely.app/privacy-policy )은 개인정보를 처리하는 방법을 설명하며 서비스 운영에 적용됩니다.',
      ],
    },
    {
      title: '서비스',
      body: [
        'Plannely는 개인용 플래너입니다. 플랫폼, 버전 및 요금제에 따라 할 일, 카테고리, 습관, 알림, 캘린더 보기, 집중 및 운동 도구, 기기 간 동기화가 포함될 수 있습니다.',
        '당사는 서비스를 발전시키면서 기능을 추가, 변경 또는 제거할 수 있습니다. 변경으로 인해 현재 결제 중인 유료 기능이 크게 축소되는 경우, 앱 또는 기타 적절한 방법으로 합리적인 기간 전에 알리도록 노력합니다.',
      ],
    },
    {
      title: '사용자 계정',
      body: [
        'Google 또는 Apple 등 앱에서 제공하는 방법으로 로그인합니다. 사용자는 해당 계정과 기기에 대한 접근을 안전하게 유지하고 Plannely 계정에서 이루어지는 활동에 대해 책임을 집니다. 누군가 허가 없이 계정에 접근했다고 생각되면 즉시 support@plannely.app 으로 알려 주십시오.',
        '제공하는 정보가 정확한지 확인해 주십시오. 서비스는 사용자에게 적용되는 법률이 허용하는 범위에서만 이용해야 합니다.',
      ],
    },
    {
      title: '아동 및 미성년자',
      body: [
        '거주지에서 구속력 있는 계약을 체결할 수 있는 연령에 도달하지 않았다면, 부모 또는 법정 대리인의 허락과 참여가 있는 경우에만 서비스를 이용할 수 있으며, 이들이 사용자를 대신하여 본 약관에 동의합니다. 아동 데이터 처리 방식은 당사의 개인정보 처리방침 제14조에 설명되어 있습니다.',
      ],
    },
    {
      title: '무료 및 유료 요금제',
      body: [
        'Plannely는 사용 한도가 있는 무료 요금제와 더 높은 한도 또는 추가 기능을 제공하는 선택적 유료 구독을 제공합니다. 현재 한도와 가격은 앱에 표시되며 변경될 수 있습니다. 무료 요금제에서는 완료한 할 일을 포함해 할 일을 삭제할 때까지 한도에 포함됩니다.',
        '구독은 구매에 사용한 계정을 통해 Apple 또는 Google Play가 판매하고 청구합니다. 스토어 규정과 함께 다음 사항이 적용됩니다.',
        [
          '현재 기간이 끝나기 최소 24시간 전 또는 스토어가 정한 기한까지 해지하지 않으면, 구독은 당시 가격으로 같은 기간만큼 자동 갱신됩니다.',
          '무료 체험이 제공되는 경우 제때 해지하지 않으면 체험 종료 시 유료 구독으로 전환됩니다. 가격과 체험 기간은 구매를 확인하기 전에 표시됩니다.',
          '구독은 Apple 또는 Google Play 계정에서 관리하거나 해지합니다. 앱이나 Plannely 계정을 삭제해도 구독은 해지되지 않습니다.',
          '환불은 스토어가 자체 정책에 따라 처리합니다. 당사는 스토어 결제를 처리하지 않으며 전체 카드 정보를 받지 않습니다.',
        ],
        '구독이 종료되면 계정은 무료 요금제로 돌아갑니다. 이로 인해 데이터가 삭제되지는 않지만, 추가 습관과 같이 무료 한도를 초과하는 기능과 콘텐츠는 다시 구독할 때까지 이용하지 못할 수 있습니다.',
      ],
    },
    {
      title: '사용자 콘텐츠',
      body: [
        '서비스에서 만든 할 일, 메모, 습관, 운동 및 기타 콘텐츠(이하 "사용자 콘텐츠")에 대한 모든 권리는 사용자에게 있습니다. 사용자는 사용자를 위해 서비스를 운영, 보호 및 지원하는 데 필요한 범위에서만 사용자 콘텐츠를 저장, 처리, 복사 및 전송할 수 있는 제한적이고 비독점적인 전 세계적 라이선스를 당사에 부여합니다. 당사는 사용자 콘텐츠를 광고에 사용하거나 판매하지 않습니다.',
        '사용자는 사용자 콘텐츠와 이를 사용할 권리를 보유하는 것에 대해 책임을 집니다. 매우 중요한 내용은 별도의 사본을 보관해 주십시오.',
        '운동 프로그램 공유 링크를 만들면 링크가 만료되거나 사용자가 취소할 때까지 링크를 가진 누구나 해당 프로그램을 보고 복사할 수 있습니다. 신뢰하는 사람에게만 링크를 공유하고, 공유하는 콘텐츠에 개인 정보를 넣지 마십시오.',
      ],
    },
    {
      title: '허용되는 이용',
      body: [
        '서비스를 이용할 때 다음 행위를 하지 않는 데 동의합니다.',
        [
          '법률 또는 타인의 권리를 침해하는 행위',
          '공유 링크를 포함하여 불법적이거나 유해하거나 악의적인 콘텐츠를 저장 또는 공유하는 행위',
          '서비스, 다른 계정 또는 당사 시스템에 무단으로 접근하거나 접근을 시도하는 행위',
          '서비스를 방해하거나 과부하를 일으키거나 요금제 한도 및 기타 기술적 제한을 우회하는 행위',
          '이 제한에도 불구하고 법률이 허용하는 경우를 제외하고 서비스를 역설계하는 행위',
          '당사의 서면 허가 없이 자동화된 수단으로 서비스에서 데이터를 추출하는 행위',
          '당사의 서면 허가 없이 서비스를 재판매하거나 상업적으로 재배포하는 행위',
        ],
      ],
    },
    {
      title: '알림 및 서비스 가용성',
      body: [
        '당사는 서비스의 안정성을 유지하기 위해 노력하지만, 알림과 동기화는 사용자의 기기, 설정, 네트워크 및 Apple과 Google 같은 제3자 서비스에 따라 달라집니다. 알림은 지연되거나 도착하지 않을 수 있습니다. 약 복용처럼 알림을 놓치면 피해나 심각한 손실이 발생할 수 있는 일에는 서비스를 유일한 알림 수단으로 사용하지 마십시오.',
        '서비스는 유지 보수, 업데이트 또는 당사가 통제할 수 없는 사건으로 인해 때때로 이용할 수 없을 수 있습니다.',
      ],
    },
    {
      title: '건강 및 운동',
      body: [
        '운동, 집중 및 습관 기능은 일반적인 자기 관리 도구입니다. 의학적 조언, 진단 또는 치료가 아닙니다. 운동을 시작하거나 변경하기 전에, 특히 건강 문제가 있다면 자격을 갖춘 의료 전문가와 상담하십시오. 통증, 어지러움 또는 불편함을 느끼면 운동을 중단하십시오. 법률이 허용하는 범위에서 이러한 기능은 사용자의 책임하에 이용합니다.',
      ],
    },
    {
      title: '당사의 지식재산권',
      body: [
        '소프트웨어, 디자인, 이름 및 로고를 포함한 서비스는 당사 또는 당사의 라이선스 제공자에게 귀속되며 지식재산권법으로 보호됩니다. 당사는 본 약관에 따라 서비스를 본래 목적으로 이용할 수 있는 개인적이고 제한적이며 비독점적이고 양도할 수 없으며 취소 가능한 라이선스를 사용자에게 부여합니다. 사용자 콘텐츠는 계속 사용자의 소유입니다.',
        '사용자가 의견이나 아이디어를 보내는 경우, 당사는 사용자에 대한 어떠한 의무 없이 이를 사용할 수 있습니다.',
      ],
    },
    {
      title: '제3자 서비스',
      body: [
        '서비스는 로그인, 결제, 알림 및 호스팅과 같은 기능에 제3자를 이용합니다. 제3자가 제공하는 서비스에는 해당 제3자의 약관과 개인정보 처리 정책이 적용됩니다. 당사는 당사가 통제하지 않는 제3자 서비스의 가용성이나 행위에 대해 책임지지 않습니다.',
      ],
    },
    {
      title: '서비스 이용 종료',
      body: [
        '사용자는 언제든지 서비스 이용을 중단하고 앱에서 또는 support@plannely.app 으로 이메일을 보내 계정을 삭제할 수 있습니다. 계정 삭제는 당사의 개인정보 처리방침에 설명되어 있습니다. 스토어 구독은 별도로 해지해야 합니다.',
        '사용자가 본 약관을 심각하게 또는 반복적으로 위반하거나, 사용자의 이용이 서비스 또는 타인에게 위험을 초래하거나, 법률이 요구하는 경우 당사는 계정을 정지하거나 폐쇄할 수 있습니다. 적절하고 허용되는 경우 사유를 설명하고 문제를 해결할 기회를 제공합니다. 당사가 서비스를 중단하는 경우 합리적인 기간 전에 알리도록 노력합니다.',
      ],
    },
    {
      title: '보증의 부인',
      body: [
        '법률이 허용하는 최대 범위에서 서비스는 "있는 그대로" 및 "이용 가능한 상태로" 제공됩니다. 당사는 서비스가 중단이나 오류 없이 작동하거나 특정 목적에 적합하거나 데이터가 절대 손실되지 않을 것임을 약속하지 않습니다. 본 약관의 어떠한 내용도 사용자에게 적용되는 법률에 따라 제한할 수 없는 보증이나 소비자 권리를 제한하지 않습니다.',
      ],
    },
    {
      title: '책임의 제한',
      body: [
        '법률이 허용하는 최대 범위에서 당사는 간접적, 부수적, 특별 또는 결과적 손해, 이익 손실, 데이터 손실 또는 놓친 일정에 대해 책임지지 않습니다. 유료 요금제의 경우 서비스와 관련된 모든 청구에 대한 당사의 총 책임은 청구 원인이 된 사건 이전 12개월 동안 사용자가 서비스에 지불한 금액으로 제한됩니다. 무료 요금제의 경우 미화 50달러 상당액으로 제한됩니다.',
        '이러한 제한은 사기, 고의적 위법 행위, 법률이 정한 경우 과실로 인한 사망 또는 신체 상해 등 법률상 배제하거나 제한할 수 없는 책임에는 적용되지 않습니다.',
      ],
    },
    {
      title: 'Apple App Store에서 다운로드한 앱',
      body: [
        'Apple App Store에서 Plannely를 다운로드한 경우 다음 추가 조건이 적용됩니다.',
        [
          '본 약관은 Apple이 아니라 사용자와 SEOTIV 사이에 체결됩니다. 앱과 그 콘텐츠에 대한 책임은 Apple이 아니라 SEOTIV에게만 있습니다.',
          '사용자의 라이선스는 Apple 미디어 서비스 이용 약관의 사용 규칙이 허용하는 대로, 사용자가 소유하거나 관리하는 Apple 브랜드 기기에서 앱을 사용하는 것으로 제한됩니다.',
          'Apple은 앱에 대한 유지 보수 또는 지원을 제공할 의무가 없습니다.',
          '앱이 적용되는 보증에 부합하지 않는 경우 Apple에 통지할 수 있으며, Apple은 구매 금액이 있다면 이를 환불합니다. 법률이 허용하는 최대 범위에서 Apple은 앱과 관련하여 다른 보증 의무를 지지 않습니다.',
          'Apple은 제조물 책임, 법률 또는 규제 준수, 소비자 보호 또는 개인정보 보호 관련 청구를 포함하여 앱 또는 앱 사용과 관련된 청구를 처리할 책임이 없습니다.',
          'Apple은 앱 또는 앱 사용이 지식재산권을 침해한다는 제3자의 청구를 조사, 방어, 합의 또는 해결할 책임이 없습니다.',
          '사용자는 미국 정부의 금수 조치 대상 국가 또는 "테러 지원" 국가로 지정된 국가에 있지 않으며, 미국 정부의 금지 또는 제한 대상자 목록에 포함되어 있지 않음을 확인합니다.',
          '앱을 사용할 때 적용되는 제3자 약관을 준수해야 합니다.',
          'Apple과 그 자회사는 본 약관의 제3자 수익자이며 사용자에 대해 본 약관을 집행할 수 있습니다.',
        ],
      ],
    },
    {
      title: '본 약관의 변경',
      body: [
        '당사는 서비스 또는 법률이 변경되면 본 약관을 업데이트할 수 있습니다. 최신 버전은 시행일과 함께 항상 https://plannely.app/terms 에 게시됩니다. 중요한 변경 사항은 앱 또는 기타 적절한 방법으로 미리 알리도록 노력합니다. 변경 사항이 시행된 후 서비스를 계속 이용하면 업데이트된 약관에 동의하는 것입니다. 동의하지 않으면 서비스 이용을 중단하고 계정을 삭제하십시오.',
      ],
    },
    {
      title: '준거법 및 분쟁',
      body: [
        '문제를 비공식적으로 해결할 수 있도록 먼저 당사에 연락해 주십시오. 본 약관은 법률 충돌 규칙과 관계없이 SEOTIV가 설립된 국가의 법률에 따릅니다. 이는 거주 국가의 소비자 보호법에 따른 강행적 보호, 그리고 해당 법률에 따라 이용할 수 있는 법원에 소를 제기할 권리를 박탈하지 않습니다.',
        '본 약관의 일부가 집행 불가능하다고 판단되더라도 나머지 부분은 계속 적용됩니다. 당사가 어떤 조항을 즉시 집행하지 않더라도 나중에 집행할 권리를 포기하는 것은 아닙니다. 사용자는 당사의 동의 없이 본 약관에 따른 권리를 양도할 수 없습니다. 당사는 사용자의 권리를 축소하지 않는 범위에서 서비스의 조직 개편 또는 매각의 일환으로 당사의 권리를 양도할 수 있습니다.',
        '본 약관의 번역본은 사용자의 편의를 위해 제공됩니다. 번역본과 영어 버전이 다른 경우, 사용자 국가의 법률이 달리 요구하지 않는 한 영어 버전이 우선합니다.',
      ],
    },
    {
      title: '문의',
      body: [
        '본 약관에 대해 궁금한 점이 있으면 support@plannely.app 으로 문의해 주십시오.',
      ],
    },
  ],
};

export default terms;
